import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import NotificationContent from './NotificationContent'

export default connect(
  null,
  {
    requestMarkNotificationAsRead: sagaActions.requestMarkNotificationAsRead,
    requestMarkNotificationAsUnread: sagaActions.requestMarkNotificationAsUnread
  },
  null,
  {
    forwardRef: true,
  }
)(NotificationContent)
